@if(selectedSale().measuredPrimaryArea){
    <div class="area overlay">
        <div class="area-number">
            {{ selectedSale().measuredPrimaryArea | dash }}
        </div>
        <div class="area-unit">m²</div>
    </div>
}

@if(imagePackages()?.length > 0) {
    <div class="image-date overlay">
        <div class="date">{{ (imagePackages()[0]?.pictureDate | date:'dd.MM.yyyy') | dash }}</div>
        <div class="info-icon"></div>
    </div>
}

<a [href]="streetViewUrl" target="_blank" class="streetview overlay">
    <div class="streetview-icon"></div>
    <div class="external-link-icon"></div>
</a>

@if (selectedSale()?.ownerInformation && selectedSale()?.ownerInformation.length > 0) {
<div class="owners overlay">
    @for (owner of selectedSale().ownerInformation.slice(0,2); track $index) {
    <div class="owner">
        <div class="owner-icon">
            <ev-circular-progress
                [value]="owner?.owner?.ownerShare?.numerator"
                [maxValue]="owner?.owner?.ownerShare?.denominator"
                [size]="'28px'"
                [strokeWidth]="10"
                [animate]="false"
            >
                <div [class]="'circular-progress-inner-content icon ' + owner.owner.identityType"></div>
            </ev-circular-progress>
        </div>
        <div class="owner-name">{{ owner.owner.name.toLowerCase() }}</div>
    </div>
    } @if (selectedSale().ownerInformation.length > 2) {
    <div class="more-owners">+{{ selectedSale().ownerInformation.length - 2 }}</div>
    }
</div>
}

<image-carousel [estateType]="propertyImageClass()" [imagePackages]="imagePackages()"> </image-carousel>
